import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, tipo_pasatiempo_ } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import DataTableService from '../../../DataTableService/DataTableService';
import SpinnerOval from '../../../../../../Services/Spinner/SpinnerOval';

const TipoPasatiempo = ({ id, permisos }) => {

    const [tipoPasatiempo, setTipoPasatiempo] = useState(null);

    useEffect(() => {
        Axios.get(`${servicios_grupogack_catalogo}/pasatiempos/getall/`, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    setTipoPasatiempo(res.data.dataResponse);
                    break;
                case 404:
                    setTipoPasatiempo([]);
                    break;
                default:
                    alert('error');
                    break;
            }
        })
        .catch(error => alert('error'));
    },[]);

    return (
        <div id={ id }>
            {   
                tipoPasatiempo
                ?   <DataTableService id={id} title={tipo_pasatiempo_}
                        columns={[
                            { field: "pasaNom", title: "Nombre" },
                            { field: "panDesc", title: "Descripción" },
                        ]}
                        data={tipoPasatiempo}
                        permisos={permisos}
                    />
                :   <SpinnerOval />
            }
        </div>
    );
}
 
export default TipoPasatiempo;
